import { useQuery } from "@tanstack/react-query";
import type { StrandLossByShift } from "../../models/StrandLossByShift";
import { getStrandLossById } from "../../repositories/StrandLossesManagerRepository";

export const useStrandLossByIdQuery = (
  strandLossId: number | null,
  enabled = true,
) =>
  useQuery({
    queryKey: ["strand-loss", strandLossId],
    queryFn: async ({ signal }): Promise<StrandLossByShift> => {
      const response = await getStrandLossById(strandLossId!, signal);
      if (!response.ok) {
        throw new Error(response.message ?? "Failed to fetch Strand Loss");
      }
      if (!response.data) {
        throw new Error("Strand Loss was not found");
      }
      return response.data;
    },
    enabled: enabled && !!strandLossId,
  });
